import { Badge } from '../ui/badge'
import type { ImportCollection } from './collection-import.types'

const CollectionBadges = ({
  collection,
}: {
  collection: Pick<ImportCollection, 'existingCollection' | 'hasNothingToImport' | 'products'>
}) => {
  return (
    <div className="flex flex-wrap gap-2">
      {collection.existingCollection ? (
        <Badge variant="secondary" size="sm">
          Collection Exists
        </Badge>
      ) : (
        <Badge variant="brand" size="sm">
          New Collection
        </Badge>
      )}
      {collection.hasNothingToImport && (
        <Badge variant="muted" size="sm">
          Nothing to Import
        </Badge>
      )}
      {collection.products.some((product) => !product.isExistingProduct) && (
        <Badge variant="success" size="sm">
          New Products
        </Badge>
      )}
      {collection.products.some(
        (product) => product.isExistingProduct && !product.isInCollection
      ) && (
        <Badge variant="warning" size="sm">
          Missing Products
        </Badge>
      )}
    </div>
  )
}

export default CollectionBadges
